



















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import {
  FundingOption,
  TransactionFilter,
  CustodianStatementLink,
  AdvisorEventType
} from "@/shared/types";
import HsaLineChart from "@/shared/components/charts/HsaLineChart.vue";
import CashAccountTabs from "@/shared/components/cash/CashAccountTabs.vue";
import HsabCashAccountTabs from "@/shared/components/cash/hsabank/HsabCashAccountTabs.vue";
import * as RouteNames from "@/employee/route-names";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useHsaStore } from "@/shared/store/hsa";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useTaxSavingsStore } from "@/shared/store/taxSavings";
import moment from "moment";

@Component({
  components: {
    HsaLineChart,
    HsabCashAccountTabs,
    CashAccountTabs,
    GenericLoadingSpinner,
  }
})
export default class CashAccountBalance extends Vue {
  partnerPortalStore = usePartnerPortalStore();
  hsaStore = useHsaStore();
  balanceStore = useHsaDailyBalanceStore();
  userStore = useUserStore();
  custodianSettingsStore = useCustodianSettingsStore();
  advisorStore = useUserAdvisorStore();
  featureFlagStore = useFeatureFlagStore();
  taxSavingsStore = useTaxSavingsStore();

  @Prop()
  page: number;

  @Prop()
  routeToCashAccountBalance: (pageNumber: number, filter: TransactionFilter) => Location;

  @Prop()
  transactionFilter: TransactionFilter;

  formatCurrency = formatCurrency;
  pageSize = 10;

  mounted (): void {
    this.partnerPortalStore.getPartnerPortalStatus();
    this.hsaStore.loadTransactionTotals();
    this.taxSavingsStore.load();
    this.balanceStore.loadBalanceOnFile();
    this.custodianSettingsStore.getCustodianSettings();
    this.balanceStore.loadInstantBalance({ force: true });
  }

  logEvent () {
    this.advisorStore.saveEvent(AdvisorEventType.SsoEStatementsLinkClick);
  }

  get displayHsaLineChart () {
    return true;
  }

  get taxSavings (): number {
    return this.taxSavingsStore.taxSavings(moment().year());
  }

  get amountReimbursed (): number {
    return this.hsaStore.totalAmountReimbursed();
  }

  get cashAccountBalanceLoaded (): boolean {
    return this.balanceStore.balanceOnFileLoaded && this.balanceStore.balanceOnFileLoaded;
  }

  get cashAccountBalance (): number {
    return this.balanceStore.instantBalance.amount || this.balanceStore.balanceOnFileAmount;
  }

  get statement (): CustodianStatementLink | boolean {
    return this.partnerPortalStore.hasPortalAccess && this.custodianSettingsStore.statementsLink;
  }

  get showTaxSavings (): boolean {
    if (!this.custodianSettingsStore.allowReimbursement) {
      return false;
    }

    return this.userStore.employeeFundingOption !== FundingOption.ErCalculateErPush;
  }

  get displayReimbursedTotal (): boolean {
    return this.custodianSettingsStore.allowReimbursement;
  }

  get numCols () {
    return this.showTaxSavings ? 3 : 2;
  }

  get numSlots () {
    if (this.showTaxSavings && this.displayReimbursedTotal) {        // both
      return 3;
    } else if (this.showTaxSavings || this.displayReimbursedTotal) { // only 1
      return 2;
    } else {                                                         // neither
      return 1;
    }
  }

  get displayHsabCashAccountTabs () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.featureFlagStore.flags.bend16322EnableHsabTransactions;
  }
}

